import axiosInstance from 'api/axiosInstance';
import { CANtrackCommentRaw } from 'api/comments/getComments';

export interface CaseActivityEntry {
  id: string;
  type: 'comment' | 'created' | 'updated';
  date: string;
  activityTitle: string;
  taskTitle: string;
  description: string;
  timeRegular: number;
  timeOver: number;
  billable: boolean;
}

/**
 * Fetches activity log entries for a case by retrieving its comments.
 * Comments represent time entries / work done on the case.
 */
const getCaseActivityLog = async (caseId: number): Promise<CaseActivityEntry[]> => {
  const payload = {
    CaseId: caseId,
    Take: 200,
  };

  try {
    const { data } = await axiosInstance.get(
      `/api/cantrackv3/ReadComments?payload=${JSON.stringify(payload)}`,
    );

    if (!data?.Data) {
      return [];
    }

    return (data.Data as CANtrackCommentRaw[]).map((raw) => ({
      id: raw.Id,
      type: 'comment' as const,
      date: raw.EntryDate,
      activityTitle: raw.ActivityTitle || '',
      taskTitle: raw.TaskTitle || '',
      description: raw.Description || '',
      timeRegular: parseFloat(raw.TimeRegular) || 0,
      timeOver: parseFloat(raw.TimeOver) || 0,
      billable: raw.Billable === 'Y',
    }));
  } catch (error) {
    console.error('[getCaseActivityLog] Failed:', error);
    throw error;
  }
};

export default getCaseActivityLog;
